import { h } from 'preact';
import { useState } from 'preact/hooks';

export function SelectEntry({
  id,
  label,
  value,
  options = [],
  onChange,
  disabled = false,
  validate,
  description,
  placeholder,
}) {
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const val = e.target.value;
    if (validate) {
      const err = validate(val);
      setError(err || null);
      if (err) return;
    }
    onChange(val);
  };

  return (
    <div class={`epx-entry epx-select${error ? ' has-error' : ''}`}>
      <label class="epx-entry-label" htmlFor={id}>{label}</label>
      <select
        id={id}
        class="epx-entry-input"
        value={value || ''}
        disabled={disabled}
        onChange={handleChange}
      >
        {placeholder && (
          <option value="" disabled>{placeholder}</option>
        )}
        {options.map(opt => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
      {error && <div class="epx-entry-error">{error}</div>}
      {description && <div class="epx-entry-description">{description}</div>}
    </div>
  );
}
